import React, { createContext, useState, useCallback, useContext } from 'react';

const SearchRefreshContext = createContext({
  refreshKey: 0,
  triggerSearchRefresh: () => {},
  triggerDelayedRefresh: () => {},
  isRefreshing: false,
});

export const useSearchRefresh = () => useContext(SearchRefreshContext);

export const SearchRefreshProvider = ({ children }) => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const triggerSearchRefresh = useCallback(() => {
    console.log('[SearchRefreshContext] Triggering immediate search refresh...');
    setRefreshKey(prevKey => prevKey + 1);
  }, []);

  const triggerDelayedRefresh = useCallback((delay = 3000) => {
    console.log(`[SearchRefreshContext] Triggering delayed search refresh in ${delay}ms...`);
    setIsRefreshing(true);
    
    setTimeout(() => {
      console.log('[SearchRefreshContext] Executing delayed search refresh...');
      setRefreshKey(prevKey => prevKey + 1);
      setIsRefreshing(false);
    }, delay);
  }, []);

  return (
    <SearchRefreshContext.Provider value={{ 
      refreshKey, 
      triggerSearchRefresh, 
      triggerDelayedRefresh,
      isRefreshing 
    }}>
      {children}
    </SearchRefreshContext.Provider>
  );
};
